import React from "react";
import { Button } from 'react-bootstrap'
import ReactLoading from 'react-loading';

interface IButtonContinueProps {
    label?: string,
    className?: string,
    disabled?: boolean,
    showLoading?: boolean,
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export class ButtonContinue extends React.Component<IButtonContinueProps> {
    constructor(props: IButtonContinueProps) {
        super(props);
    }

    render() {
        return (
            <Button className={"btnContinue " + (this.props.className ? this.props.className : "")}
                    disabled={this.props.disabled}
                    onClick={this.props.onClick}>
                {this.props.label ? this.props.label : "Continue" } { this.props.showLoading ? <ReactLoading type={"spin"} className="continue-loading" color={"#ffffff"} height={'20px'} width={'20px'} /> : <i className="fas fa-arrow-right"></i>} 
            </Button>
        );
    }
}

export default ButtonContinue;